import { render, staticRenderFns } from "./content-delete.view.vue?vue&type=template&id=572d9dc6&"
import script from "./content-delete.view.vue?vue&type=script&lang=ts&"
export * from "./content-delete.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports